import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./style.css";
import { VideoPlayer } from "../videoPlayer";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import useAppAccessor from "../../../../hooks/useappAccessor";
import { useDispatch } from "react-redux";
import { setStreamHeight, setStreamWidth } from "../../../live-main/livemain.actions";

const calculateVideoFit = (stats: any): string => {
  if (
    ((stats.receiveResolutionHeight == 640 || stats.captureResolutionHeight == 360) && (stats.receiveResolutionWidth == 640 || stats.captureResolutionWidth == 360)) ||
    ((stats.receiveResolutionWidth == 640 || stats.captureResolutionWidth == 360) && (stats.receiveResolutionHeight == 640 || stats.captureResolutionHeight == 360)) ||
    ((stats.receiveResolutionWidth == 360 || stats.sendResolutionWidth == 360 || stats.captureResolutionWidth == 360)
     && (stats.sendResolutionHeight == 640 || stats.receiveResolutionHeight == 640 || stats.captureResolutionHeight == 640)) ||
    ((stats.receiveResolutionWidth == 360 || stats.sendResolutionWidth == 360 || stats.captureResolutionWidth == 360)
     && (stats.sendResolutionHeight == 480 || stats.receiveResolutionHeight == 480 || stats.captureResolutionHeight == 480)) ||
    ((stats.receiveResolutionWidth == 640 || stats.sendResolutionWidth == 640 || stats.captureResolutionWidth == 640)
     && (stats.sendResolutionHeight == 480 || stats.receiveResolutionHeight == 480 || stats.captureResolutionHeight == 480)) ||
    ((stats.receiveResolutionHeight == 960 || stats.captureResolutionHeight == 720) && (stats.receiveResolutionWidth == 960 || stats.captureResolutionWidth == 720)) ||
    ((stats.receiveResolutionWidth == 960 || stats.captureResolutionWidth == 720) && (stats.receiveResolutionHeight == 960 || stats.captureResolutionHeight == 720)) ||
    ((stats.receiveResolutionWidth == 960 || stats.sendResolutionWidth == 960 || stats.captureResolutionWidth == 960)
     && (stats.sendResolutionHeight == 720 || stats.receiveResolutionHeight == 720 || stats.captureResolutionHeight == 720))
  ) {
    return 'contain';
  } else if ((stats.receiveResolutionHeight < 10 || stats.captureResolutionHeight < 10) && (stats.receiveResolutionWidth < 10 || stats.captureResolutionWidth < 10)) {
    return 'unset';
  } else {
    return 'contain';
  }
};

const TEST_LAYOUT_4_COPRESENTERS = false;
const TEST_SIMULATE_USER_CHANGES = false;

const VideoRoomCopresenterLayout = (props: any) => {
  const { pinnedLayoutUid, onTogglePin, canPin = false } = props;
  const [tempArray, setTempArray] = useState([1]);
  const [tempArraySpeaker, setTempArraySpeaker] = useState([1]);
  const [containerH, setContainerH] = useState(100);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [simulatedUsers, setSimulatedUsers] = useState<any[]>([]);
  const [userFits, setUserFits] = useState<Record<string, string>>({});
  const reduxDispatch = useDispatch();
  const { getInteractions, getControls } = useAppAccessor();
  const {
    isCameraOn,
    isMicOn,
    coPresenterInfo,
    roleCopresenter,
    isScreenSharing,
  } = getControls();
  const { interactionData } = getInteractions();

  const mockUsers = useMemo(() => {
    const baseTimestamp = Date.now();
    return [
      {
        uid: 1001,
        timestamp: baseTimestamp,
        firstName: "John",
        lastName: "Doe",
        isCameraOn: true,
        isMicOn: true,
        rotateDegree: 0,
        videoTrack: null,
        audioTrack: null,
        containerColor: "#3B82F6",
      },
      {
        uid: 1002,
        timestamp: baseTimestamp + 1,
        firstName: "Jane",
        lastName: "Smith",
        isCameraOn: true,
        isMicOn: true,
        rotateDegree: 0,
        videoTrack: null,
        audioTrack: null,
        containerColor: "#10B981",
      },
      {
        uid: 1003,
        timestamp: baseTimestamp + 2,
        firstName: "Bob",
        lastName: "Johnson",
        isCameraOn: true,
        isMicOn: true,
        rotateDegree: 0,
        videoTrack: null,
        audioTrack: null,
        containerColor: "#F59E0B",
      },
      {
        uid: 1004,
        timestamp: baseTimestamp + 3,
        firstName: "Alice",
        lastName: "Williams",
        isCameraOn: true,
        isMicOn: true,
        rotateDegree: 0,
        videoTrack: null,
        audioTrack: null,
        containerColor: "#8B5CF6",
      },
    ];
  }, []);

  useEffect(() => {
    if (!TEST_SIMULATE_USER_CHANGES) return;

    let userCount = 1;
    const baseTimestamp = Date.now();

    const interval = setInterval(() => {
      const baseUsers = [
        {
          uid: 1001,
          timestamp: baseTimestamp + Date.now(),
          firstName: "John",
          lastName: "Doe",
          isCameraOn: true,
          isMicOn: true,
          rotateDegree: 0,
          videoTrack: null,
          audioTrack: null,
          containerColor: "#3B82F6",
        },
        {
          uid: 1002,
          timestamp: baseTimestamp + Date.now() + 1,
          firstName: "Jane",
          lastName: "Smith",
          isCameraOn: true,
          isMicOn: true,
          rotateDegree: 0,
          videoTrack: null,
          audioTrack: null,
          containerColor: "#10B981",
        },
        {
          uid: 1003,
          timestamp: baseTimestamp + Date.now() + 2,
          firstName: "Bob",
          lastName: "Johnson",
          isCameraOn: true,
          isMicOn: true,
          rotateDegree: 0,
          videoTrack: null,
          audioTrack: null,
          containerColor: "#F59E0B",
        },
        {
          uid: 1004,
          timestamp: baseTimestamp + Date.now() + 3,
          firstName: "Alice",
          lastName: "Williams",
          isCameraOn: true,
          isMicOn: true,
          rotateDegree: 0,
          videoTrack: null,
          audioTrack: null,
          containerColor: "#8B5CF6",
        },
      ];

      setSimulatedUsers(baseUsers.slice(0, userCount));
      userCount = userCount >= 4 ? 1 : userCount + 1;
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const displayUsers = useMemo(() => {
    if (TEST_LAYOUT_4_COPRESENTERS) {
      return TEST_SIMULATE_USER_CHANGES && simulatedUsers.length > 0
        ? simulatedUsers
        : mockUsers;
    }
    return props.users;
  }, [mockUsers, props.users, simulatedUsers]);

  const isPresenter = () => {
    return window.location.href.indexOf("/stream") > -1 || roleCopresenter;
  };

  const isMobile = () => {
    return window.innerWidth < 768 ||
      /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
  };

  useEffect(() => {
    setTempArray(displayUsers.length > 1 ? [1] : []);
    setTempArraySpeaker(
      displayUsers.length > 4
        ? [1, 2, 3, 4]
        : displayUsers.length > 3
        ? [1, 2, 3]
        : displayUsers.length > 2
        ? [2, 3]
        : [1]
    );
  }, [displayUsers]);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    var offset =
      interactionData.filter((data: any) => data.attributes.shouldShow === true)
        .length == 0
        ? 0
        : 180;

    if (!isMobile()) {
      offset = -100;
    }

    var carouselOffset = 0;
    if (isMobile() && displayUsers.length >= 2) {
      carouselOffset = 80;
    }

    const containerElement = document.getElementById("idVideoRoomContainer");
    const offsetHeight = containerElement?.offsetHeight ?? 300;

    const hasMultipleSpeakers = displayUsers.length > 2;

    if (displayUsers.length <= 1) {
      setContainerH(offsetHeight - carouselOffset);
    } else if (displayUsers.length == 2) {
      setContainerH(
        offsetHeight -
          offset -
          (isPresenter() || hasMultipleSpeakers ? 40 : 60) -
          carouselOffset - (isMobile() ? 40 : 0)
      );
    } else {
      setContainerH(
        offsetHeight -
          offset -
          (isPresenter() || hasMultipleSpeakers ? 40 : 60) -
          carouselOffset -
          120
      );
    }
  }, [isScreenSharing, displayUsers?.length, interactionData, windowHeight]);

  useEffect(() => {
    reduxDispatch(setStreamHeight(0));
    reduxDispatch(setStreamWidth(0));

    const intervalId = setInterval(() => {
      const newFits: Record<string, string> = {};
      
      displayUsers.forEach((user: any) => {
        if (!user.videoTrack) {
          return;
        }

        const stats = user.videoTrack.getStats();
        
        if (stats.captureResolutionHeight !== undefined && stats.captureResolutionHeight > 0) {
          reduxDispatch(setStreamHeight(stats.captureResolutionHeight));
        }
        if (stats.captureResolutionWidth !== undefined && stats.captureResolutionWidth > 0) {
          reduxDispatch(setStreamWidth(stats.captureResolutionWidth));
        }

        let newFit = calculateVideoFit(stats);

        const isMobile = /Mobi|Android/i.test(navigator.userAgent);
        if (isMobile) {
          newFit = 'contain';
        }

        newFits[user.uid] = newFit;
      });

      setUserFits(prevFits => {
        const hasChanged = Object.keys(newFits).some(uid => prevFits[uid] !== newFits[uid]);
        return hasChanged ? newFits : prevFits;
      });
    }, 500);

    return () => clearInterval(intervalId);
  }, [displayUsers, reduxDispatch]);

  const isPinned = useCallback((uid: any) => {
    if (pinnedLayoutUid === null || typeof pinnedLayoutUid === "undefined") {
      return false;
    }
    return String(pinnedLayoutUid) === String(uid);
  }, [pinnedLayoutUid]);

  return (
    <div className="h-full w-full" style={{ position: "absolute", zIndex: 0 }}>
      <div
        style={{
          justifyContent: "center",
          width: "100%",
          // position: 'relative',
          // top: '50%',
          // transform: 'translateY(-50%)'
        }}
      >
        {displayUsers.length == 1 && (
          <div
            className={"speaker-view"}
            style={{
              borderRadius: "9px",
              height: containerH,
              marginTop: tempArraySpeaker.length < 2 ? 0: 70,
            }}
          >
            <div
              className={
                tempArray && tempArray.length == 2
                  ? "main-speaker_twoview"
                  : "main-speaker"
              }
            >
              <div
                className="main-video"
                style={{
                  backgroundColor:
                    TEST_LAYOUT_4_COPRESENTERS &&
                    displayUsers[0]?.containerColor
                      ? displayUsers[0].containerColor
                      : "transparent",
                }}
              >
                {/* Render the active speaker's video here */}
                {displayUsers.length > 0 && (
                  <VideoPlayer
                    isOne={true}
                    isTwo={false}
                    num={0}
                    showInfo={displayUsers && displayUsers.length > 1}
                    width={
                      document.getElementById("idVideoRoomContainer")
                        ?.offsetWidth ?? window.innerWidth
                    }
                    height={containerH / (1 + tempArray.length)}
                    key={displayUsers[0].timestamp}
                    user={displayUsers[0]}
                    videoFit={userFits[displayUsers[0].uid] || 'cover'}
                    showExampleVideo={TEST_LAYOUT_4_COPRESENTERS}
                    canPin={canPin}
                    isPinned={isPinned(displayUsers[0].uid)}
                    onTogglePin={onTogglePin}
                  />
                )}
              </div>
            </div>
            <div
              style={{ borderRadius: "9px" }}
              className={
                tempArray.length == 1
                  ? "thumbnail-speakers_removeSpeaker"
                  : tempArray.length == 2
                  ? "thumbnail-speakers_twoview"
                  : tempArray.length > 2
                  ? "thumbnail-speakers"
                  : "thumbnail-speakers"
              }
            >
              {tempArraySpeaker.map((participant, index) => (
                <div
                  key={index}
                  className={`thumbnail active`}
                  style={{
                    backgroundColor:
                      TEST_LAYOUT_4_COPRESENTERS &&
                      displayUsers[1 + index]?.containerColor
                        ? displayUsers[1 + index].containerColor
                        : "transparent",
                  }}
                >
                  {/* Render the participant's video here */}
                  {displayUsers.length > 1 + index && (
                    <VideoPlayer
                      isOne={true}
                      isTwo={false}
                      num={index + 1}
                      showInfo={true}
                      width={
                        (document.getElementById("idVideoRoomContainer")
                          ?.offsetWidth ?? window.innerWidth) /
                          (displayUsers.length - 1) -
                        12
                      }
                      height={containerH / 2 - 4}
                      key={displayUsers[1 + index].timestamp}
                      user={displayUsers[1 + index]}
                      videoFit={userFits[displayUsers[1 + index].uid] || 'cover'}
                      showExampleVideo={TEST_LAYOUT_4_COPRESENTERS}
                      canPin={canPin}
                      isPinned={isPinned(displayUsers[1 + index].uid)}
                      onTogglePin={onTogglePin}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {displayUsers.length == 2 && (
          <div
            className={"speaker-view"}
            style={{
              borderRadius: "9px",
              height: containerH,
              marginTop: tempArraySpeaker.length < 2 ? (isMobile() ? 90 : 0) : 70,
            }}
          >
            <div
              className={
                tempArray && tempArray.length == 2
                  ? "main-speaker_twoview"
                  : "main-speaker"
              }
            >
              <div
                className="main-video"
                style={{
                  backgroundColor:
                    TEST_LAYOUT_4_COPRESENTERS &&
                    displayUsers[0]?.containerColor
                      ? displayUsers[0].containerColor
                      : "transparent",
                }}
              >
                {/* Render the active speaker's video here */}
                {displayUsers.length > 0 && (
                  <VideoPlayer
                    isOne={false}
                    isTwo={true}
                    num={0}
                    showInfo={displayUsers && displayUsers.length > 1}
                    width={
                      (document.getElementById("idVideoRoomContainer")
                        ?.offsetWidth ?? window.innerWidth) - 12
                    }
                    height={containerH / (1 + tempArray.length) - 4}
                    key={displayUsers[0].timestamp}
                    user={displayUsers[0]}
                    videoFit={userFits[displayUsers[0].uid] || 'cover'}
                    showExampleVideo={TEST_LAYOUT_4_COPRESENTERS}
                    canPin={canPin}
                    isPinned={isPinned(displayUsers[0].uid)}
                    onTogglePin={onTogglePin}
                  />
                )}
              </div>
            </div>
            <div
              style={{ borderRadius: "9px" }}
              className={
                tempArray.length == 1
                  ? "thumbnail-speakers_removeSpeaker"
                  : tempArray.length == 2
                  ? "thumbnail-speakers_twoview"
                  : tempArray.length > 2
                  ? "thumbnail-speakers"
                  : "thumbnail-speakers"
              }
            >
              {tempArraySpeaker.map((participant, index) => (
                <div
                  key={index}
                  className={`thumbnail active`}
                  style={{
                    backgroundColor:
                      TEST_LAYOUT_4_COPRESENTERS &&
                      displayUsers[1 + index]?.containerColor
                        ? displayUsers[1 + index].containerColor
                        : "transparent",
                  }}
                >
                  {/* Render the participant's video here */}
                  {displayUsers.length > 1 + index && (
                    <VideoPlayer
                      isOne={false}
                      isTwo={true}
                      num={index + 1}
                      showInfo={true}
                      width={
                        (document.getElementById("idVideoRoomContainer")
                          ?.offsetWidth ?? window.innerWidth) /
                          (displayUsers.length - 1) -
                        12
                      }
                      height={containerH / 2 - 4}
                      key={displayUsers[1 + index].timestamp}
                      user={displayUsers[1 + index]}
                      videoFit={userFits[displayUsers[1 + index].uid] || 'cover'}
                      showExampleVideo={TEST_LAYOUT_4_COPRESENTERS}
                      canPin={canPin}
                      isPinned={isPinned(displayUsers[1 + index].uid)}
                      onTogglePin={onTogglePin}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {displayUsers.length == 3 && (
          <div
            className={"speaker-view"}
            style={{
              borderRadius: "9px",
              height: containerH,
              marginTop: isMobile() ? 100 : 0,
            }}
          >
            <div
              className={
                tempArray && tempArray.length == 2
                  ? "main-speaker_twoview"
                  : "main-speaker"
              }
            >
              <div
                className="main-video"
                style={{
                  backgroundColor:
                    TEST_LAYOUT_4_COPRESENTERS &&
                    displayUsers[0]?.containerColor
                      ? displayUsers[0].containerColor
                      : "transparent",
                }}
              >
                {/* Render the active speaker's video here */}
                {displayUsers.length > 0 && (
                  <VideoPlayer
                    isOne={false}
                    isTwo={false}
                    num={0}
                    showInfo={displayUsers && displayUsers.length > 1}
                    width={
                      (document.getElementById("idVideoRoomContainer")
                        ?.offsetWidth ?? window.innerWidth) - 12
                    }
                    height={(2 / 3) * containerH - 4}
                    key={displayUsers[0].timestamp}
                    user={displayUsers[0]}
                    videoFit={userFits[displayUsers[0].uid] || 'cover'}
                    showExampleVideo={TEST_LAYOUT_4_COPRESENTERS}
                    canPin={canPin}
                    isPinned={isPinned(displayUsers[0].uid)}
                    onTogglePin={onTogglePin}
                  />
                )}
              </div>
            </div>

            <div
              style={{ borderRadius: "9px" }}
              className={
                tempArray.length == 1
                  ? "thumbnail-speakers_removeSpeaker"
                  : tempArray.length == 2
                  ? "thumbnail-speakers_twoview"
                  : tempArray.length > 2
                  ? "thumbnail-speakers"
                  : "thumbnail-speakers"
              }
            >
              {tempArraySpeaker.map((participant, index) => (
                <div
                  key={index}
                  className={`thumbnail active`}
                  style={{
                    backgroundColor:
                      TEST_LAYOUT_4_COPRESENTERS &&
                      displayUsers[1 + index]?.containerColor
                        ? displayUsers[1 + index].containerColor
                        : "transparent",
                  }}
                >
                  {/* Render the participant's video here */}
                  {displayUsers.length > 1 + index && (
                    <VideoPlayer
                      isOne={false}
                      isTwo={false}
                      num={index + 1}
                      showInfo={true}
                      width={
                        (document.getElementById("idVideoRoomContainer")
                          ?.offsetWidth ?? window.innerWidth) /
                          (displayUsers.length - 1) -
                        12
                      }
                      height={(1 / 3) * containerH - 4}
                      key={displayUsers[1 + index].timestamp}
                      user={displayUsers[1 + index]}
                      videoFit={userFits[displayUsers[1 + index].uid] || 'cover'}
                      showExampleVideo={TEST_LAYOUT_4_COPRESENTERS}
                      canPin={canPin}
                      isPinned={isPinned(displayUsers[1 + index].uid)}
                      onTogglePin={onTogglePin}
                    />
                  )}
                </div>
              ))}
            </div>

          </div>
        )}

        {displayUsers.length == 4 && (
          <div
            className={"speaker-view"}
            style={{
              borderRadius: "9px",
              height: containerH,
              marginTop: isMobile() ? 100 : 0,
            }}
          >
            <div
              className={
                tempArray && tempArray.length == 2
                  ? "main-speaker_twoview"
                  : "main-speaker"
              }
            >
              <div
                className="main-video"
                style={{
                  backgroundColor:
                    TEST_LAYOUT_4_COPRESENTERS &&
                    displayUsers[0]?.containerColor
                      ? displayUsers[0].containerColor
                      : "transparent",
                }}
              >
                {/* Render the active speaker's video here */}
                {displayUsers.length > 0 && (
                  <VideoPlayer
                    isOne={false}
                    isTwo={false}
                    num={0}
                    showInfo={displayUsers && displayUsers.length > 1}
                    width={
                      (document.getElementById("idVideoRoomContainer")
                        ?.offsetWidth ?? window.innerWidth) - 12
                    }
                    height={(2 / 3) * containerH - 4}
                    key={displayUsers[0].timestamp}
                    user={displayUsers[0]}
                    videoFit={userFits[displayUsers[0].uid] || 'cover'}
                    showExampleVideo={TEST_LAYOUT_4_COPRESENTERS}
                    canPin={canPin}
                    isPinned={isPinned(displayUsers[0].uid)}
                    onTogglePin={onTogglePin}
                  />
                )}
              </div>
            </div>
            <div
              style={{ borderRadius: "9px" }}
              className={
                tempArray.length == 1
                  ? "thumbnail-speakers_removeSpeaker"
                  : tempArray.length == 2
                  ? "thumbnail-speakers_twoview"
                  : tempArray.length > 2
                  ? "thumbnail-speakers"
                  : "thumbnail-speakers"
              }
            >
              {tempArraySpeaker.map((participant, index) => (
                <div
                  key={index}
                  className={`thumbnail active`}
                  style={{
                    backgroundColor:
                      TEST_LAYOUT_4_COPRESENTERS &&
                      displayUsers[1 + index]?.containerColor
                        ? displayUsers[1 + index].containerColor
                        : "transparent",
                  }}
                >
                  {/* Render the participant's video here */}
                  {displayUsers.length > 1 + index && (
                    <VideoPlayer
                      isOne={false}
                      isTwo={false}
                      num={index + 1}
                      showInfo={true}
                      width={
                        (document.getElementById("idVideoRoomContainer")
                          ?.offsetWidth ?? window.innerWidth) /
                          (displayUsers.length - 1) -
                        12
                      }
                      height={(1 / 3) * containerH - 4}
                      key={displayUsers[1 + index].timestamp}
                      user={displayUsers[1 + index]}
                      videoFit={userFits[displayUsers[1 + index].uid] || 'cover'}
                      showExampleVideo={TEST_LAYOUT_4_COPRESENTERS}
                      canPin={canPin}
                      isPinned={isPinned(displayUsers[1 + index].uid)}
                      onTogglePin={onTogglePin}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoRoomCopresenterLayout;
